import { render, staticRenderFns } from "./ChristmasPriceRange.vue?vue&type=template&id=6f792c0d&name=christmas-price-range&"
import script from "./ChristmasPriceRange.vue?vue&type=script&lang=js&"
export * from "./ChristmasPriceRange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports